import { SourcesProvider, SourcesAuthType } from '@api/types.gen';

import { PasswordField } from './PasswordField';
import { UsernameField } from './UsernameField';
import { GitProviderSelect } from './GitProviderSelect';
import { AuthTypeSelector } from './AuthTypeSelector';
import { providerConfigs } from './providerConfig';

export type CredentialValues = {
  provider: SourcesProvider;
  type: SourcesAuthType;
  username?: string;
  password?: string;
};

type Props = {
  values: CredentialValues;
  isEditing?: boolean;
  errors?: { username?: string; password?: string };
  onChange: (values: Partial<CredentialValues>) => void;
};

export function ProviderCredentialFields({
  values: { provider, type, username, password },
  isEditing = false,
  errors,
  onChange,
}: Props) {
  const config = providerConfigs[provider];

  let { passwordLabel } = config;
  if (provider === SourcesProvider.PROVIDER_CUSTOM) {
    passwordLabel =
      type === SourcesAuthType.AUTH_TYPE_BASIC ? 'Password' : 'Access Token';
  }

  return (
    <div className="flex flex-col gap-y-4">
      <GitProviderSelect
        value={provider}
        onChange={(value) => {
          const providerConfig = providerConfigs[value];
          onChange({
            provider: value,
            type: providerConfig.fixedAuthType ?? type,
          });
        }}
      />

      {provider === SourcesProvider.PROVIDER_CUSTOM && (
        <AuthTypeSelector
          value={type}
          onChange={(value) => onChange({ type: value })}
        />
      )}

      <UsernameField
        value={username || ''}
        onChange={(value) => onChange({ username: value })}
        tooltip={config.usernameTooltip}
        error={errors?.username}
      />

      <PasswordField
        value={password || ''}
        onChange={(value) => onChange({ password: value })}
        label={passwordLabel}
        tooltip={config.passwordTooltip}
        error={errors?.password}
        required={!isEditing}
      />
    </div>
  );
}
